
function getKey(component) {
    var tag = component.$options._componentTag;
    var config = component.$options.localStorage;
    var key = config.key;
   
    if(key && component[key])
        key = component[key];

    return `componentState_${key}_${tag}`;
}

const ComponentLocalStoragePlugin = {
    install(Vue) {
        Vue.mixin({
            created() {
                if(!this.$options.localStorage) return;
                var key = getKey(this);
                var data = localStorage.getItem(key);
                if(!data) return;

                try {
                    var obj = JSON.parse(data);
                    for(var prop in obj) {
                        if(this.$data.hasOwnProperty(prop))
                            this[prop] = obj[prop];
                    }
                }
                catch(error) {
                    console.log(error);
                }
            },
            methods: {
                $saveStateToLocalStorage() {
                    var config = this.$options.localStorage || {};
                    var props = config.props;
                    if(!props) return;
                    
                    var key = getKey(this);
                    var stateToSave = {};

                    for(var prop in this.$data) {
                        if(props.includes(prop))
                            stateToSave[prop] = this[prop];
                    }

                    localStorage.setItem(key, JSON.stringify(stateToSave));
                }
            }
        })
    }
}

export { ComponentLocalStoragePlugin }


// WEBPACK FOOTER //
// ./src/framework/utils/component-local-storage-plugin.js